// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.eb94386ed',
  revision: 'eb94386ed',
  branch: 'develop',
  date: 'Tue, 08 Sep 2026 13:57:34 GMT'
};